import { render, staticRenderFns } from "./viewResolution.vue?vue&type=template&id=5ef26f8a&scoped=true&"
import script from "./viewResolution.vue?vue&type=script&lang=js&"
export * from "./viewResolution.vue?vue&type=script&lang=js&"
import style0 from "./viewResolution.vue?vue&type=style&index=0&id=5ef26f8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef26f8a",
  null
  
)

export default component.exports